import type { ThemeTokens } from '@/shared/ui/theme/tokens';
import { C } from '@/shared/ui/theme/tokens';

interface CardReaderProps {
  scanning: boolean;
  size?: number;
  T: ThemeTokens;
  /** CSS class that drives the pulse-ring animation. Defaults to 'mi-anim-pulse-ring'. */
  animationClass?: string;
}

export function CardReader({ scanning, size = 195, T: _T, animationClass = 'mi-anim-pulse-ring' }: CardReaderProps) {
  return (
    <div
      style={{
        position: 'relative',
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        background: '#161D31',
        boxShadow: `0 0 0 1.5px #2485F4, 0 0 0 4px ${C.primary}44, 0 16px 56px rgba(0,0,0,.45)`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div
        style={{
          position: 'absolute',
          inset: 0,
          background: `radial-gradient(circle at 50% 45%, ${C.primary}28 0%, transparent 65%)`,
        }}
      />
      {scanning && (
        <>
          {[0, 0.5, 1].map((delay) => (
            <div
              key={delay}
              className={animationClass}
              style={{
                position: 'absolute',
                width: size * 0.6,
                height: size * 0.6,
                borderRadius: '50%',
                border: `2px solid ${C.primary}`,
                opacity: 0.55 - delay * 0.15,
                animationDelay: `${delay}s`,
              }}
            />
          ))}
        </>
      )}
      <div style={{ position: 'relative', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6, zIndex: 2 }}>
        <svg width={size * 0.42} height={size * 0.42} viewBox="0 0 64 64" fill="none">
          <defs>
            <linearGradient id="mi-cardGrad" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%"   stopColor={C.primary} stopOpacity=".95" />
              <stop offset="100%" stopColor={C.blue}    stopOpacity=".95" />
            </linearGradient>
          </defs>
          <rect x="6" y="18" width="38" height="26" rx="3.5" fill="url(#mi-cardGrad)" stroke="#fff" strokeOpacity=".25" strokeWidth="1" />
          <rect x="11" y="24" width="8" height="6" rx="1.2" fill="#FFD27A" />
          <line x1="11" y1="27" x2="19" y2="27" stroke="#7A5318" strokeWidth=".7" />
          <line x1="15" y1="24" x2="15" y2="30" stroke="#7A5318" strokeWidth=".7" />
          <line x1="11" y1="35" x2="32" y2="35" stroke="#fff" strokeOpacity=".55" strokeWidth="1.4" strokeLinecap="round" />
          <line x1="11" y1="39" x2="26" y2="39" stroke="#fff" strokeOpacity=".4"  strokeWidth="1.2" strokeLinecap="round" />
          <path d="M48 22 Q 54 31 48 40" stroke={scanning ? '#fff' : '#ffffff77'} strokeWidth="2" strokeLinecap="round" fill="none" />
          <path d="M52 19 Q 60 31 52 43" stroke={scanning ? '#fff' : '#ffffff55'} strokeWidth="2" strokeLinecap="round" fill="none" />
          <path d="M56 16 Q 66 31 56 46" stroke={scanning ? '#fff' : '#ffffff33'} strokeWidth="2" strokeLinecap="round" fill="none" />
        </svg>
        <div style={{ fontSize: 9, fontWeight: 700, color: '#fff', letterSpacing: '.12em', textShadow: '0 1px 4px rgba(0,0,0,.6)' }}>
          {scanning ? 'LEYENDO…' : 'ACERQUE TARJETA'}
        </div>
      </div>
      <div
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          background: 'radial-gradient(circle,transparent 48%,rgba(0,0,0,.55) 100%)',
          pointerEvents: 'none',
          zIndex: 3,
        }}
      />
    </div>
  );
}
